import { MessageContext } from 'fluent/compat';
import _ from 'lodash';

const getQuestionAnswer = (questionId, questionnaireResponses) => {
  if (!_.isEmpty(questionnaireResponses)) {
    const response = _.first(questionnaireResponses);
    const responseItem = _.find(response.questionnaireResponseItems, { questionnaireItemId: questionId });
    if (responseItem) {
      if (responseItem.questionnaireResponseItemAnswers.length > 1) {
        return responseItem.questionnaireResponseItemAnswers;
      }
      const itemAnswer = _.first(responseItem.questionnaireResponseItemAnswers);
      return itemAnswer;
    }
    return null;
  }
  return null;
};

export const getQuestionsObject = (questionsArray, questionnaireResponses = []) => {
  const questionsObject = {};
  questionsArray.forEach((question, index) => {
    const answer = getQuestionAnswer(question.linkId, questionnaireResponses);
    questionsObject[question.linkId] = {
      index,
      ...question,
      answer,
    };
  });
  return questionsObject;
};


export const formatBannerText = (minutes) => {
  const context = new MessageContext('en-US');
  context.addMessages(`
button = {$minutes ->
  [0]     Let's go
  [one]   1 min
 *[other] {$minutes} mins
}
  `);
  return context.format(context.getMessage('button'), { minutes });
};

export const optionToValue = (option) => {
  const optionKeys = _.keys(option);
  const valueKey = _.find(optionKeys, o => _.startsWith(o, 'value'));

  return {
    ...(option.extension ? { extension: option.extension } : {}),
    value: option[valueKey],
    valueType: _.lowerCase(_.replace(valueKey, 'value', '')),
  };
};
